// extracted by mini-css-extract-plugin
export default {"success-card":"integrationSettings_success-card__PDKCA","error-card":"integrationSettings_error-card__gdEgy","loading-customers":"integrationSettings_loading-customers__GmzGv"};